import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  ScrollArea,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateProviderZoneDto, CreateProviderZoneSchema } from "@reactive-resume/dto";
import { useCreateProviderZone } from "@/client/services/payment-provider/create-provider-zones";
import { useAllProviders } from "@/client/services/payment-provider/providers";
import { useDialog } from "@/client/stores/dialog";
import { countries } from "@reactive-resume/utils";

export const CreateProviderZoneDialog = () => {
  const { isOpen, close, mode } = useDialog("create-zone");
  const form = useForm({
    defaultValues: { country: "", currency: "", priority: 1, providerId: "" },
  });
  const createProviderZone = useCreateProviderZone();
  const { providers } = useAllProviders();

  const onSubmit = (data: any) => {
    const payload: CreateProviderZoneDto = {
      country: data.country,
      currency: data.currency,
      priority: Number(data.priority),
      providerId: data.providerId,
    };
    createProviderZone.mutate(payload, {
      onSuccess: () => {
        form.reset();
        close();
      },
    });
  };

  if (mode !== "create") return null;

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nouvelle Zone Fournisseur</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              name="country"
              control={form.control}
              render={({ field }) => (
                //champs du pays
                <FormItem className="my-3">
                  <FormLabel>Pays</FormLabel>
                  <Select
                    {...field}
                    onValueChange={(value) => {
                      form.setValue("country", value);
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Choisissez votre pays" />
                    </SelectTrigger>
                    <SelectContent>
                      <ScrollArea orientation="vertical" className="h-[300px]">
                        {countries.map((item) => (
                          <SelectItem value={item.value}>{item.label}</SelectItem>
                        ))}
                      </ScrollArea>
                    </SelectContent>
                  </Select>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="currency"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Devise</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="priority"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Priorité</FormLabel>
                  <FormControl>
                    <Input type="number" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="providerId"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Fournisseur</FormLabel>
                  <Select onValueChange={field.onChange}>
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Sélectionner..." />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      {providers?.map((provider) => (
                        <SelectItem key={provider.id} value={provider.id}>
                          {provider.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit">Créer</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
